import React, { FC, useState } from 'react';
import { CircularProgress, IconButton, StandardTextFieldProps, TextField } from '@material-ui/core';
import { MdSave as SaveIcon } from '@react-icons/all-files/md/MdSave';
import { createUseStyles } from '../../../../../../../theming';

interface Props extends StandardTextFieldProps {
  label: string;
  defaultValue?: string;
  onSave: (value?: string) => void;
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
  },
});

const EditableTextField: FC<Props> = ({ label, defaultValue, onSave, ...props }) => {
  const [newValue, setNewValue] = useState<string | undefined>(defaultValue);
  const [helperText, setHelperText] = useState<string>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const handleSave = async () => {
    try {
      setError(undefined);
      setLoading(true);

      await onSave(newValue);

      setHelperText(undefined);
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  const handleBlur = () => {
    if (newValue !== defaultValue) {
      setHelperText('Pensez à enregistrer les modifications');
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewValue(event.target.value);
  };

  const hasBeenChanged = newValue !== defaultValue;

  return (
    <div className={classes.root}>
      <TextField
        {...props}
        variant='outlined'
        label={label}
        onBlur={handleBlur}
        onChange={handleChange}
        defaultValue={defaultValue}
        error={!!error}
        helperText={error ? error : helperText}
        InputProps={{
          endAdornment: loading ? (
            <CircularProgress size={17} />
          ) : (
            hasBeenChanged && (
              <IconButton onClick={handleSave}>
                <SaveIcon />
              </IconButton>
            )
          ),
        }}
        fullWidth
      />
    </div>
  );
};

export default EditableTextField;
